var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2023 24.3769L27.2 24.3793V24.3734L26.3133 25.2542C25.1666 26.4155 23.4965 26.8932 21.9091 26.5142C20.3098 26.0862 18.7895 25.4048 17.4058 24.4959C16.1202 23.6743 14.9289 22.7139 13.8533 21.6318C12.8637 20.6494 11.9746 19.5706 11.1991 18.4118C10.3509 17.1647 9.67954 15.8063 9.2041 14.3751C8.65907 12.6937 9.11072 10.8487 10.3708 9.60926L11.4091 8.57095C11.6978 8.28096 12.1669 8.27994 12.4568 8.56862L12.4591 8.57095L15.7374 11.8493C16.0274 12.1379 16.0284 12.607 15.7397 12.8969L15.7374 12.8993L13.8124 14.8243C13.2601 15.3706 13.1906 16.2387 13.6491 16.8659C14.3453 17.8215 15.1158 18.7206 15.9533 19.5551C16.887 20.4929 17.9021 21.3459 18.9866 22.1043C19.6133 22.5414 20.4628 22.4677 21.0049 21.9293L22.8657 20.0393C23.1544 19.7493 23.6235 19.7483 23.9134 20.037L23.9157 20.0393L27.1999 23.3293C27.49 23.6179 27.491 24.0869 27.2023 24.3769Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.459991e79e8c47e461e0b5c1905ed42b.svg";
export { ForwardRef as ReactComponent };